/**
 * High-quality Unsplash imagery for FalZilla visuals.
 * All URLs use crop=entropy&cs=srgb&fm=jpg&q=85 for consistent quality.
 */

export const HERO_IMAGES = {
  main: "https://images.unsplash.com/photo-1601987177651-8edfe6c20009?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  cosmic: "https://images.unsplash.com/photo-1519681393784-d120267933ba?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  tarot: "https://images.unsplash.com/photo-1607773709367-06b7a91f7e4a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const FORTUNE_COVERS = {
  kahve: "https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  el: "https://images.unsplash.com/photo-1601987177651-8edfe6c20009?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  tarot: "https://images.unsplash.com/photo-1633158829585-23ba8f7c8caf?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  ruya: "https://images.unsplash.com/photo-1518709414768-a88981a4515d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  pirinc: "https://images.unsplash.com/photo-1536304993881-ff6e9eefa2a6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  iskambil: "https://images.unsplash.com/photo-1541278107931-e006523892df?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  katina: "https://images.unsplash.com/photo-1518199266791-5375a83190b7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  burc: "https://images.unsplash.com/photo-1543872084-c7bd3822856f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  ask: "https://images.unsplash.com/photo-1518199266791-5375a83190b7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};
